var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('div',{staticClass:"empty-text"},[_vm._v("请选择车型信息")])])
}]

export { render, staticRenderFns }